/* @jsxImportSource @emotion/react */
import React from 'react'

import { IconInColorBox } from '@slite/components'

import { HelpHtml } from './HelpHtml'

// Renders a help note the way Slite does: its icon and title, then the raw HTML
// export.
export function HelpDoc({
  title,
  html,
  iconShape,
  iconColor,
}: {
  title: string
  html: string
  iconShape: string | null
  iconColor: string | null
}) {
  return (
    <article>
      <div className="margin-bottom-16">
        {iconShape && (
          <div
            className="inline-block margin-right-12"
            style={{
              transform: `translateY(-3px)`,
            }}
          >
            <IconInColorBox
              iconShape={iconShape}
              iconColor={iconColor ?? undefined}
              size={38}
            />
          </div>
        )}
        <h1
          data-test-id="helpArticleTitle"
          className="inline font-family-title font-weight-semibold shade-05"
          css={{ margin: 0, fontSize: 32, lineHeight: 1.2 }}
        >
          {title}
        </h1>
      </div>
      <HelpHtml html={html} />
    </article>
  )
}
